import { gql } from "@apollo/client";

const DEDUCTION_TYPE_FIELDS = `
  typeId
  name
  deductionTypeKey
  categoryId
  categoryName
  parentId
  parentName
  helpText
  metadata
  subTypeCount
  isLinked
  createdAt
  createdBy
  updatedAt
  updatedBy
`;

export const GET_MASTER_DATA_DEDUCTION_TYPES = gql`
  query MasterDataDeductionTypes($params: MasterDataDeductionTypesParamsInput!) {
    masterDataDeductionTypes(params: $params) {
      total
      page
      limit
      items {
        ${DEDUCTION_TYPE_FIELDS}
      }
    }
  }
`;

export const GET_MASTER_DATA_DEDUCTION_SUB_TYPES = gql`
  query MasterDataDeductionSubTypes(
    $params: MasterDataDeductionSubTypesParamsInput!
  ) {
    masterDataDeductionSubTypes(params: $params) {
      total
      page
      limit
      items {
        ${DEDUCTION_TYPE_FIELDS}
      }
    }
  }
`;
